module.exports = __webpack_public_path__ + "82bd590c0f6836eca7065939fbcadd10.svg";